var map;

function showBranchesMap () {
    if (!navigator.geolocation) {
        geolocationMessage("Lo sentimos. Tu navegador no acepta geolocalización.")
        return
    }
    geolocationMessage("Por favor, permite el acceso a tu ubicación.")
    Promise.all([
        getPosition(),
        getBranches()
    ]).then((messages) => {
        const position = messages[0];
        const currentPosition = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
        };
        const branches = sortBranchesByDistance(messages[1], currentPosition);
        map = showGoogleMap(currentPosition)
        const infoWindows = [];
        branches.forEach((branch, index) => {showBranch(branch, index, map, infoWindows)})
    }).catch((error) => {
        if (error instanceof GeolocationPositionError) {
            switch (error.code) {
                case 1:
                    geolocationMessage("Has rechazado la solicitud de geolocalización.<br>Por favor, recarga la página y reinténtalo.")
                    break;
                default:
                    geolocationMessage("Hubo un error el obtener la geolocalización.<br>Por favor, recarga la página y reinténtalo.")
            }
        } else {
            geolocationMessage(error.message)
        }
    })
}

function showBranch(branch, index, map, infoWindows) {
    const position = {
        lat: +branch.ceswp_latitud_map,
        lng: +branch.ceswp_longitud_map
    }
    const infowindow = new google.maps.InfoWindow({
        content: branchInfoWindowContent(branch),
        maxWidth: 500
    });
    infoWindows.push(infowindow)
    const marker = new google.maps.Marker({
        position: position,
        map: map,
        title: branch.ceswp_name,
        icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'
      });
    marker.addListener('click', () => {
        infoWindows.forEach(item => item.close())
        infowindow.open(map, marker)
    });
    if (index === 0) {
        map.setCenter(position)
        infowindow.open(map, marker)
    }
}

function branchInfoWindowContent(branch) {
    const schedule = branchSchedule(branch);
    const scheduleString = getScheduleString(schedule)
    const branchStatus = isBranchOpened(schedule, new Date());
    const branchStatusString = schedule.length?
        `<div class="status ${branchStatus? "open" : "closed"}">
            ${branchStatus? "Abierto": "Cerrado"}
        </div>` : "";
    return `
    <article class="infowindow-wrapper">
        <h1>${branch.ceswp_name}</h1>
        ${branchStatusString}
        <div class="address">${branch.ceswp_address}</div>
        ${scheduleString}
    </article>
    `
}

function isBranchOpened(schedule, time) {
    const todaySchedule = schedule.find(item => {
        return item.days.some(day => day === time.getDay())
    })
    if (!todaySchedule) {return false}
    const todayRanges = todaySchedule.range.map(item => item.split(":"));
    const from = new Date(time.getFullYear(), time.getMonth(), time.getDate(), todayRanges[0][0], todayRanges[0][1])
    const to = new Date(time.getFullYear(), time.getMonth(), time.getDate(), todayRanges[1][0], todayRanges[1][1])
    if (time.getTime() < to.getTime() && time.getTime() > from.getTime()) {
        return true
    } else {
        return false
    }
}

function getScheduleString(schedule) {
    if (!schedule.length) {
        return `<div class="no-schedule">No hay información de horario.</div>`
    }
    const listElements = schedule.reduce((acc, current) => {
        return acc + `<li><span class="name">${current.name}:</span>${current.displayString}</li>`
    }, "")
    return `<ul class="schedule">${listElements}</ul>`
}

function branchSchedule(branch) {
    const schedule = [
        {
            name: "Lun a Vie",
            range: [
                branch.ceswp_monday_to_friday_start_hour,
                branch.ceswp_monday_to_friday_end_hour
            ],
            days: [1, 2, 3, 4, 5]
        },
        {
            name: "Sáb",
            range: [
                branch.ceswp_saturday_start_hour,
                branch.ceswp_saturday_end_hour
            ],
            days: [6]
        },
        {
            name: "Dom",
            range: [
                branch.ceswp_sunday_start_hour,
                branch.ceswp_sunday_end_hour
            ],
            days: [0]
        }
    ]
    .filter(item => item.range[0] && item.range[1])
    .map(item => {
        const hoursWithoutSenconds = item.range.map(range => range.substring(0, 5))
        item.displayString = hoursWithoutSenconds.join(" a ") + " hrs."
        return item
    })
    return schedule
}

function showGoogleMap(position) {
    const mapContainer = document.getElementById('map');
    document.getElementById('containerRed').classList.add('hidden')
    mapContainer.classList.remove('hidden')
    const map = new google.maps.Map(mapContainer, {
        center: position,
        zoom: 13
    });
    const marker = new google.maps.Marker({
        position: position,
        map: map,
    });
    return map
}

const getPosition = function () {
    return new Promise(function (resolve, reject) {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
}

const getBranches = function () {
    return fetch('/wp-json/wp/v1/branches')
        .then(function(response) {
            if (!response.ok) {
                return Promise.reject(
                    Error(`Lo sentimimos, ocurrió un error ${response.status} al consultar las sucursales: ${response.statusText}`)
                )
            }
            return response.json();
        })
        .then(function(jsonResponse) {
            const branchesWithLocation = jsonResponse.filter(item => item.ceswp_latitud_map && item.ceswp_longitud_map)
            if (!branchesWithLocation.length) {
                return Promise.reject(
                    Error("Lo sentimos, no hay sucursales disponibles con geolocalización.")
                )
            }
            return branchesWithLocation
        })
        .catch(error => {
            return Promise.reject(Error(error.message))
        })
}

function calculateDistance(lat1, lon1, lat2, lon2, unit) {
    var radlat1 = Math.PI * lat1/180
    var radlat2 = Math.PI * lat2/180
    var theta = lon1-lon2
    var radtheta = Math.PI * theta/180
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist)
    dist = dist * 180/Math.PI
    dist = dist * 60 * 1.1515
    if (unit=="K") { dist = dist * 1.609344 }
    if (unit=="N") { dist = dist * 0.8684 }

    return dist
}

function sortBranchesByDistance(branches, position) {
    return branches
    .map(branch => {
        branch.distance = calculateDistance(
            position.lat, 
            position.lng, 
            branch.ceswp_latitud_map.replace(/,.*/, ""), 
            branch.ceswp_longitud_map.replace(/,.*/, ""), 
            "K");
        return branch
    })
    .sort((a, b) => a.distance - b.distance);
}

function geolocationMessage(message) {
    const errorMessage = document.querySelector(".container-red-map .error-message")
    const showBranchesButton = document.querySelector(".container-red-map button")
    errorMessage.innerHTML = message
    errorMessage.classList.remove("hidden")
    showBranchesButton.classList.add("hidden")
}